import {LogLevel} from '@/config/telemetry'

let telemetryInstance: ((level: LogLevel, message: string[]) => void) | null =
  null

export const setTelemetryInstance = (
  logFunction: (level: LogLevel, message: string[]) => void,
) => {
  telemetryInstance = logFunction
}

export const logTelemetry = (level: LogLevel, message: string[]) => {
  if (telemetryInstance) {
    telemetryInstance(level, message)
  } else {
    console.warn('Telemetria não inicializada!')
  }
}
